import Api from 'utils/Api';
import Auth from 'utils/Auth';

const signin = (data) => {
  const response = Api.post('/auth/login/', data);
  return response;
};

/** Login step 2: exchange mfa_token + otp/backup code for access/refresh tokens. */
const verifyLoginOtp = (data) => {
  const response = Api.post('/auth/login/verify-otp/', data);
  return response;
};

const employeeLogin = (data) => {
  const response = Api.post('/capture/legacy-employees/login/', data);
  return response;
};

const verifyUserOtp = (data) => {
  const response = Api.post(`/capture/legacy-employees/verify-otp/`, data);
  return response;
};

const signup = (data) => {
  const response = Api.post('/users/register/', data);
  return response;
};

const forgotPassword = (data) => {
  const response = Api.post('/auth/users/reset-password/', data);
  return response;
};

const verifyToken = (data) => {
  const response = Api.post('/auth/users/verify-token/', data);
  return response;
};

const updateUser = (data) => {
  const response = Api.post('/auth/set-password/', data);
  return response;
};

const changePassword = (data) => {
  const response = Api.post('/auth/users/change-password/', data);
  return response;
};

/** Generate TOTP secret + QR for the authenticated user (2FA still disabled until confirm). */
const setup2fa = () => {
  const response = Api.post('/auth/users/2fa/setup/');
  return response;
};

/** Confirm enrollment with authenticator OTP and receive backup codes. */
const confirm2fa = (data) => {
  const response = Api.post('/auth/users/2fa/confirm/', data);
  return response;
};

/** Disable 2FA for the authenticated user (DELETE /auth/users/2fa/). */
const disable2fa = () => {
  const response = Api.delete('/auth/users/2fa/');
  return response;
};

const createUser = (data) => {
  const response = Api.post('/users/register/', data);
  return response;
};

export function getUsers({ queryKey }) {
  const [, queryParams] = queryKey;
  return Api.get(`/users/`, {
    params: queryParams
  });
}

export function activateAdmin({ queryKey }) {
  const [, queryParams] = queryKey;
  return Api.get(`/users/${queryParams.id}/activate/`);
}

export function deactivateAdmin({ queryKey }) {
  const [, queryParams] = queryKey;
  return Api.get(`/users/${queryParams.id}/suspend/`);
}

const getCurrentUser = () => {
  const decodedToken = Auth.getDecodedJwt();
  const token = Auth.getToken();

  if (token) {
    Api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete Api.defaults.headers.common.Authorization;
  }

  const response = Api.get(`/auth/users/${decodedToken.user_id}/`);
  return response;
};

const AuthApis = {
  signin,
  verifyLoginOtp,
  signup,
  forgotPassword,
  updateUser,
  changePassword,
  setup2fa,
  confirm2fa,
  disable2fa,
  verifyToken,
  getCurrentUser,
  createUser,
  activateAdmin,
  deactivateAdmin,
  employeeLogin,
  verifyUserOtp
};

export default AuthApis;
